import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { RevealView } from '../../common/motion';
import { resolveIntroBrokerName } from '../utils';
import IntroFaqItem from './IntroFaqItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroFaqSection = function IntroFaqSection() {
  var _useState = useState(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];
  /**
   * watch
   */


  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var brokerName = useWatch({
    control: control,
    name: 'brokerName'
  });
  var faqTitle = useWatch({
    control: control,
    name: 'faqTitle'
  });
  var faqItems = useWatch({
    control: control,
    name: 'faqItems'
  });
  /**
   * methods
   */

  var toggleQuestionAction = function toggleQuestionAction(index) {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col space-y-10 py-16 md:flex-row md:space-x-20 md:space-y-0 md:py-24",
    children: [/*#__PURE__*/_jsx(RevealView, {
      direction: "left",
      className: "md:flex-1",
      children: /*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "font-['Playfair_Display',serif] text-3xl font-black leading-tight text-[#202020] md:text-[52px]",
        children: faqTitle
      })
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-4 md:flex-[2]",
      children: faqItems.map(function (item, index) {
        return /*#__PURE__*/_jsx(RevealView, {
          delay: index * 0.04,
          children: /*#__PURE__*/_jsx(IntroFaqItem, {
            item: {
              question: resolveIntroBrokerName(item.question, brokerName),
              answer: resolveIntroBrokerName(item.answer, brokerName)
            },
            expanded: activeIndex === index,
            onToggle: function onToggle() {
              return toggleQuestionAction(index);
            }
          })
        }, item.question);
      })
    })]
  });
};

export default IntroFaqSection;